DJ.addBehavior('js-tabs-animation', '.js-tabs-animation', {
  attach: function(context, settings, behavior) {
    var wrap = jQuery(this);
    var btn = wrap.find('.js-tabs-animation-btn');
    var prevDataId = null;
    var prevDataIdOut = null;
    btn.click(function (e) {
      if (jQuery(this).is('button')) {
        e.preventDefault();
      }
      if (!jQuery(this).hasClass('active')) {
        var imagesWrap = wrap.find('.tabs-animation__images');
        var dataId = jQuery(this).attr('data-id');
        var dataColor = jQuery(this).attr('data-color');
        imagesWrap.css({ backgroundColor: dataColor ? dataColor : '#676E86' });
        btn.removeClass('active').removeAttr('style').attr('aria-selected', 'false');
        wrap.find('.content-text').removeClass('active animationToBottom animationToTop');
        wrap.find('.tabs-animation__img').removeClass('active animationToBottom animationToTop animationToBottomOut animationToTopOut');
        wrap.find('.tabs-animation__img[data-id="'+prevDataId+'"]').addClass('active');
        if (Number(dataId) > Number(prevDataId)) {
          wrap.find('.content-text[data-id="'+dataId+'"]').addClass('active animationToTop');
          wrap.find('.tabs-animation__img[data-id="'+dataId+'"]').addClass('active animationToTop');
          wrap.find('.tabs-animation__img[data-id="'+prevDataId+'"]').addClass('active animationToBottomOut');
          setTimeout(function () {
            wrap.find('.tabs-animation__img[data-id="'+prevDataId+'"]').removeClass('active')
          },200);
        } else {
          wrap.find('.content-text[data-id="'+dataId+'"]').addClass('active animationToBottom');
          wrap.find('.tabs-animation__img[data-id="'+dataId+'"]').addClass('active animationToBottom');
          wrap.find('.tabs-animation__img[data-id="'+prevDataId+'"]').addClass('active animationToTopOut');
          setTimeout(function () {
            wrap.find('.tabs-animation__img[data-id="'+prevDataId+'"]').removeClass('active')
          },200);
        }
        jQuery(this).addClass('active').css({ color: dataColor }).attr('aria-selected', 'true');
        setTimeout(function () {
          prevDataId = dataId;
        }, 210);
      }
    });
    wrap.find('.js-tabs-animation-btn').eq(0).click();
  },

  detach: function(context, settings) {}
});
